import type { HTMLAttributes } from "react";
import { cn } from "../../lib/cn.js";

export interface BadgeProps extends HTMLAttributes<HTMLSpanElement> {
  variant?: "default" | "accent" | "outline" | "success" | "warning" | "danger";
}

const variantClasses = {
  default: "bg-surface-overlay text-content-secondary border-border-default",
  accent: "bg-accent-muted text-accent border-accent-muted",
  outline: "bg-transparent text-content-secondary border-border-default",
  success: "bg-status-active-bg text-status-active-text border-status-active-border",
  warning: "bg-status-nigo-bg text-status-nigo-text border-status-nigo-border",
  danger: "bg-status-rejected-bg text-status-rejected-text border-status-rejected-border",
};

export function Badge({ className, variant = "default", children, ...props }: BadgeProps) {
  return (
    <span
      className={cn(
        "inline-flex items-center rounded-full border px-2 py-0.5 text-[11px] font-medium leading-4",
        variantClasses[variant],
        className
      )}
      {...props}
    >
      {children}
    </span>
  );
}
